import { RouterModule, Routes } from '@angular/router';

import { PublicGuard } from 'src/app/utils/public.guard';
import { LoginComponent } from 'src/app/public/login/login.component';
import { ForgetComponent } from 'src/app/public/forget/forget.component';
import { ResetComponent } from 'src/app/public/reset/reset.component';
import { NotFoundComponent } from 'src/app/public/not-found/not-found.component';
import { LeadsComponent } from 'src/app/private/modules/leads/leads.component';
import { MainComponent } from 'src/app/private/layout/main/main.component';
import { LeadProfileComponent } from 'src/app/private/components/leads/lead-profile/lead-profile.component';
import { AuthGuard } from 'src/app/utils/auth.guard';
import { ConfigureLeadsComponent } from 'src/app/private/configrations/configure-leads/configure-leads.component';
import { PipelineConfigurationComponent } from 'src/app/private/configrations/pipeline-configuration/pipeline-configuration.component';
import { ConfigureUsersComponent } from 'src/app/private/configrations/configure-users/configure-users.component';
import { WhatsappTemplateComponent } from 'src/app/private/configrations/whatsapp-template/whatsapp-template.component';
import { EmailTemplateComponent } from 'src/app/private/configrations/email-template/email-template.component';
import { ContactGroupComponent } from 'src/app/private/configrations/contact-group/contact-group.component';
import { ManageCampaignComponent } from 'src/app/private/modules/manage-campaign/manage-campaign.component';
import { RegistrationComponent } from 'src/app/private/modules/registration/registration.component';
import { ApplicationsComponent } from 'src/app/private/modules/applications/applications.component';
import { LeadFormComponent } from 'src/app/private/components/leads/lead-form/lead-form.component';
import { TicketsComponent } from 'src/app/private/modules/tickets/tickets.component';
import { AnalyticsComponent } from 'src/app/private/modules/analytics/analytics.component';
import { SalesMailHubComponent } from 'src/app/private/modules/sales-mail-hub/sales-mail-hub.component';
import { ReportsComponent } from 'src/app/private/modules/reports/reports.component';
import { LeadReportDetailsComponent } from 'src/app/private/components/reports/lead-report-details/lead-report-details.component';
import { TicketReportListComponent } from 'src/app/private/components/reports/ticket-report-list/ticket-report-list.component';
import { TicketReportDetailsComponent } from 'src/app/private/components/reports/ticket-report-details/ticket-report-details.component';
import { DomainAuthenticationComponent } from 'src/app/private/configrations/domain-authentication/domain-authentication.component';
import { EnrollmentsComponent } from 'src/app/private/modules/enrollments/enrollments.component';
import { FeesConfigurationComponent } from 'src/app/private/configrations/fees-configuration/fees-configuration.component';
import { AcademicYearConfigurationComponent } from 'src/app/private/configrations/academic-year-configuration/academic-year-configuration.component';
import { FeeBreakdownComponent } from 'src/app/private/configrations/fee-breakdown/fee-breakdown.component';
import { BatchConfigurationComponent } from 'src/app/private/configrations/batch-configuration/batch-configuration.component';
import { CourseConfigurationComponent } from 'src/app/private/configrations/course-configuration/course-configuration.component';
import { DepartmentConfigurationComponent } from 'src/app/private/configrations/department-configuration/department-configuration.component';
import { RollNumberConfigurationComponent } from 'src/app/private/configrations/roll-number-configuration/roll-number-configuration.component';
import { DialingGroupConfigurationComponent } from 'src/app/private/configrations/dialing-group-configuration/dialing-group-configuration.component';
import { CallCampaignDetailsComponent } from 'src/app/private/components/dialing-group/call-campaign-details/call-campaign-details.component';
import { AdmissionComponent } from 'src/app/private/modules/admission/admission.component';
import { AdmissionProfileComponent } from 'src/app/private/components/admission/admission-profile/admission-profile.component';
import { StudentComponent } from 'src/app/private/modules/student/student.component';
import { StudentProfileComponent } from 'src/app/private/components/student/student-profile/student-profile.component';
import { HostelConfigurationComponent } from 'src/app/private/configrations/hostel-configuration/hostel-configuration.component';
import { TransportConfigurationComponent } from 'src/app/private/configrations/transport-configuration/transport-configuration.component';
import { ScholarshipConfigurationComponent } from 'src/app/private/configrations/scholarship-configuration/scholarship-configuration.component';
import { NgModule } from '@angular/core';
import { StudentTempProfileComponent } from 'src/app/private/components/temp-student-profile/student-temp-profile/student-temp-profile.component';
import { LearningComponent } from 'src/app/private/modules/learning/learning.component';
import { ContactsComponent } from 'src/app/private/modules/contacts/contacts.component';
import { ConfigurationPanelComponent } from 'src/app/private/configrations/configuration-panel/configuration-panel.component';
import { FormBuilderComponent } from 'src/app/private/configrations/form-builder/form-builder.component';
import { PublicFormComponent } from 'src/app/public/public-form/public-form.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: "full",
    title: "TINA"
  },

  {
    path: 'login',
    component: LoginComponent,
    title: "TINA",
    canActivate: [PublicGuard]
  },
  {
    path: 'forget-password',
    component: ForgetComponent,
    title: "Forget Password",
    canActivate: [PublicGuard]
  },
  {
    path: 'reset-password/:type/:token',
    component: ResetComponent,
    title: "Reset Password",
    canActivate: [PublicGuard]
  },
  {
    path: 'capture-leads/:key',
    component: LeadFormComponent,
    title: "TINA"
  },
  {
    path: 'public/form/:token',
    component: PublicFormComponent,
    title: "Form Submission"
  },
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: 'leads',
        pathMatch: 'full' // Ensures an exact match to redirect
      },
      {
        path: 'analytics',
        component: AnalyticsComponent,
        title: "Analytics",
        data: {
          title: "Analytics"
        }
      },
      {
        path: 'leads',
        component: LeadsComponent,
        title: "Manage Leads",
        data: {
          title: "Manage Leads"
        }
      },
      {
        path: 'manage-tickets',
        component: TicketsComponent,
        title: "Manage Tickets",
        data: {
          title: "Manage Tickets"
        }
      },
      {
        path: 'leads/:id',
        component: LeadProfileComponent,
        title: "Lead Profile",
        data: {
          title: "Lead Profile"
        }
      },
      {
        path: 'dashboard',
        component: LeadsComponent,
        title: "Manage Leads",
        data: {
          title: "Manage Leads"
        }
      },
      {
        path: 'manage-campaign',
        component: ManageCampaignComponent,
        title: "Manage Campaigns",
        data: {
          title: "Manage Campaigns"
        }
      },
      {
        path: 'manage-campaign/call-campaign-details/:id',
        component: CallCampaignDetailsComponent,
        title: "Manage Campaigns",
        data: {
          title: "Manage Campaigns"
        }
      },
      {
        path: 'registration',
        component: RegistrationComponent,
        title: "Registration",
        data: {
          title: "Registration"
        }
      },
      {
        path: 'application',
        component: ApplicationsComponent,
        title: "Applications",
        data: {
          title: "Applications"
        }
      },
      {
        path: 'enrollment',
        component: EnrollmentsComponent,
        title: "Enrollments",
        data: {
          title: "Enrollments"
        }
      },
      {
        path: 'admission',
        component: AdmissionComponent,
        title: "Admissions",
        data: {
          title: "Admissions"
        }
      },
      {
        path: 'student',
        component: StudentComponent,
        title: "Students",
        data: {
          title: "Students"
        }
      },
      {
        path: 'learning',
        component: LearningComponent,
        title: "Learning",
        data: {
          title: "Learning"
        }
      },
      {
        path: 'registration/:id',
        component: LeadProfileComponent,
        title: "Registration Profile",
        data: {
          title: "Registration Profile"
        }
      },
      {
        path: 'application/:id',
        component: LeadProfileComponent,
        title: "Application Profile",
        data: {
          title: "Application Profile"
        }
      },
      {
        path: 'enrollment/:id',
        component: LeadProfileComponent,
        title: "Enrollment Profile",
        data: {
          title: "Enrollment Profile"
        }
      },
      {
        path: 'admission/:id',
        component: AdmissionProfileComponent,
        title: "Admission Profile",
        data: {
          title: "Admission Profile"
        }
      },
      {
        path: 'student/:id',
        component: StudentProfileComponent,
        title: "Student Profile",
        data: {
          title: "Student Profile"
        }
      },
      {
        path: 'student/profile/:id',
        component: StudentProfileComponent,
        title: "Student Profile",
        data: {
          title: "Student Profile"
        }
      },
      {
        path: 'student/stage/profile',
        component: StudentTempProfileComponent,
        title: "Student Temp Profile",
        data: {
          title: "Student Temp Profile"
        }
      },
      {
        path: 'sales-mail-hub',
        component: SalesMailHubComponent,
        title: "Sales Mail Hub",
        data: {
          title: "Sales Mail Hub"
        }
      },
      {
        path: 'reports',
        component: ReportsComponent,
        title: "Reports",
        data: {
          title: "Reports"
        }
      },
      {
        path: 'reports/leads/:slug',
        component: LeadReportDetailsComponent,
        title: "Leads Report",
        data: {
          title: "Leads Report"
        }
      },
      {
        path: 'reports/tickets/:slug',
        component: TicketReportDetailsComponent,
        title: "Tickets Report",
        data: {
          title: "Tickets Report"
        }
      },
      {
        path: 'contacts',
        component: ContactsComponent,
        title: "Contacts",
        data: {
          title: "Contacts"
        }
      },
      {
        path: 'settings/configuration-users',
        component: ConfigureUsersComponent,
        title: "Manage Leads",
        data: {
          title: "Manage Leads"
        }
      },
      {
        path: 'settings/configuration-fields',
        component: ConfigureLeadsComponent,
        title: "Manage Leads Configuration",
        data: {
          title: "Manage Leads Configuration"
        }
      },
       {
        path: 'settings/configuration-panel',
        component: ConfigurationPanelComponent,
        title: "Configuration Panel",
        data: {
          title: "Configuration Panel"
        }
      },
      {
        path: 'settings/pipeline-configuration',
        component: PipelineConfigurationComponent,
        title: "Pipeline Configuration",
        data: {
          title: "Pipeline Configuration"
        }
      },
       {
        path: 'settings/hostel-configuration',
        component: HostelConfigurationComponent,
        title: "Hostel Configuration",
        data: {
          title: "Hostel Configuration"
        }
      },
      {
        path: 'settings/transport-configuration',
        component: TransportConfigurationComponent,
        title: "Transport Configuration",
        data: {
          title: "Transport Configuration"
        }
      },
      {
        path: 'settings/scholarship-configuration',
        component: ScholarshipConfigurationComponent,
        title: "Scholarship Configuration",
        data: {
          title: "Scholarship Configuration"
        }
      },
      {
        path: 'settings/configuration-email-templates',
        component: EmailTemplateComponent,
        title: "Email Templates",
        data: {
          title: "Email Templates"
        }
      },
       {
        path: 'settings/configuration-whatsapp-templates',
        component: WhatsappTemplateComponent,
        title: "Whatsapp Templates",
        data: {
          title: "Whatsapp Templates"
        }
      },
      {
        path: 'settings/configuration-contact-groups',
        component: ContactGroupComponent,
        title: "Contact Groups",
        data: {
          title: "Contact Groups"
        }
      },
      {
        path: 'settings/configuration-domain-authentication',
        component: DomainAuthenticationComponent,
        title: "Domain Authentication",
        data: {
          title: "Domain Authentication"
        }
      },
      {
        path: 'settings/department-configuration',
        component: DepartmentConfigurationComponent,
        title: "Department Configuration",
        data: {
          title: "Department Configuration"
        }
      },
      {
        path: 'settings/roll-number-configuration',
        component: RollNumberConfigurationComponent,
        title: "Roll Number Configuration",
        data: {
          title: "Roll Number Configuration"
        }
      },
      {
        path: 'settings/course-configuration',
        component: CourseConfigurationComponent,
        title: "Course Configuration",
        data: {
          title: "Course Configuration"
        }
      },
      {
        path: 'settings/academic-year-configuration',
        component: AcademicYearConfigurationComponent,
        title: "Academic Year Configuration",
        data: {
          title: "Academic Year Configuration"
        }
      },
      {
        path: 'settings/batch-configuration',
        component: BatchConfigurationComponent,
        title: "Batch Configuration",
        data: {
          title: "Batch Configuration"
        }
      },
      {
        path: 'settings/configuration-fees',
        component: FeesConfigurationComponent,
        title: "Fees Configuration",
        data: {
          title: "Fees Configuration"
        }
      },
      {
        path: 'settings/configuration-fees/:id',
        component: FeeBreakdownComponent,
        title: "Fees Breakdown",
        data: {
          title: "Fees Breakdown"
        }
      },
      {
        path: 'settings/configuration-dialing-groups',
        component: DialingGroupConfigurationComponent,
        title: "Dialing Groups",
        data: {
          title: "Dialing Groups"
        }
      },
      {
        path: 'settings/form-builder',
        component: FormBuilderComponent,
        title: "Dynamic Form Builder",
        data: {
          title: "Dynamic Form Builder"
        }
      }
    ]
  },


  { path: 'notfound', component: NotFoundComponent },
  { path: '**', redirectTo: '/notfound' }
];
